export default __webpack_public_path__ + "static/media/Sign-Red-24x24.822f988f.svg";